<template>
    <div class="room__main">
        <div v-if="streams && !streams.length && (users.length === 1 || !users.length)" class="room__messages-box">
            <div class="room__messages">
                <strong class="room__caption r-strong" v-if="consultationInfoMessage">{{ consultationInfoMessage }}</strong>
                <div class="room__message-text" v-if="!interlocutorNotEnter">
                    <template v-if="!mediaAccess">
                        <p>
                            Вы не включили микрофон или веб-камеру. Пожалуйста, проверьте Ваши настройки<br>
                            <a :href="'/pdf/hardware_setup_information.pdf'" target="_blank">Инструкция по настройке оборудования</a>
                        </p>
                    </template>
                    <template v-else-if="timeDiff < 0">
                        <p>Пожалуйста, проверьте Вашу веб-камеру</p>
                    </template>
                    <template v-if="streams && !streams.length && (users.length === 1 || !users.length)">
                        <p>Если у Вас возникли вопросы, можете задать их по телефону +7 (841) 223-11-25</p>
                    </template>
                </div>
                <div class="room__message-text" v-else>
                    <template v-if="user.type == 'patient' && !existingAppeal">
                        <form @submit.prevent="sendAppeal">
                            <div class="chat__inputbox">
                                <textarea v-model="appeal" placeholder="Текст жалобы..." required="required" class="chat__input r-text-input textarea"></textarea>
                            </div>
                            <button type="submit" class="chat__enter r-button button" :disabled="disableAppealButton">Оставить жалобу</button>
                        </form>
                    </template>
                    <template v-else-if="user.type == 'doctor'">
                        <button class="chat__enter r-button button" @click="endConference(false)">Пациент не явился на консультацию</button>
                    </template>
                </div>
            </div>
        </div>
        <div v-else-if="streams && !streams.length && users.length > 1" class="room__messages-box">
            <div class="room__messages">
                <strong class="room__caption r-strong">Консультация уже началась, но ваш собеседник не включил ни микрофон, ни веб-камеру</strong>
            </div>
        </div>
        <session v-if="token && token.length"></session>
        <controls></controls>
    </div>
</template>

<script>
	import Session from "./Session";
    import Controls from "./controls/Controls";
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';
    import {mapState, mapActions, mapMutations} from 'vuex';
    import api from "../../../../../admin/api/api";
    import OT from "@opentok/client";

    dayjs.extend(utc);

    export default {
        components: {
            Session,
            Controls
        },
        data() {
            return {
                patientEnter: null,
                doctorEnter: null,
                timer: 1000,
                consultationInfoMessage: null,
                consultationInfoInternal: null,
                timeDiff: null,
                interlocutorNotEnter: false,
                appeal: null,
                existingAppeal: false,
                disableAppealButton: false,
            }
        },
        computed: {
            ...mapState('conference', [
                'token',
                'streams',
                'users',
                'mediaAccess'
            ]),
            ...mapState([
                'consultation',
                'user'
            ])
        },
        methods: {
            ...mapActions('conference', [
                'getOpenTokData',
                'endConference',
            ]),
            ...mapMutations('conference', [
                'setUsers',
                'setUser',
                'spliceUser'
            ]),
            checkConsultationMessageInfo() {
                if (this.consultation && this.consultation.start_at) {
                    this.timeDiff = dayjs.createFromTimezone(null, this.user.time_zone).diff(dayjs.createFromTimezone(this.consultation.start_at, this.user.time_zone), 'second');

                    if (this.user.type == 'patient' && this.timeDiff > 0 && this.timeDiff < 480) {
                        this.consultationInfoMessage = 'Пожалуйста, ожидайте врача';

                    } else if (this.user.type == 'patient' && !this.doctorEnter && this.timeDiff >= 480) {
                        this.consultationInfoMessage = 'Извините за ожидание. Оставьте жалобу, если врач не явился на консультацию. Мы обязательно свяжемся с Вами.';

                        this.interlocutorNotEnter = true;

                        clearInterval(this.consultationInfoInternal);
                    } else if (this.user.type == 'doctor' && !this.patientEnter && this.timeDiff >= 1200) {
                        this.consultationInfoMessage = null;

                        this.interlocutorNotEnter = true;

                        clearInterval(this.consultationInfoInternal);
                    }
                }
            },
            setAppealInfo() {
                if (this.consultation.payment_id) {
                    this.consultationInfoMessage = 'Пожалуйста, ожидайте врача или завершите консультацию, используя кнопку "Завершить консультацию". Возврат денежных средств будет произведен в полном объеме на Ваш баланс.';
                } else {
                    this.consultationInfoMessage = 'Пожалуйста, ожидайте врача или завершите консультацию, используя кнопку "Завершить консультацию"';
                }
            },
            sendAppeal() {
                this.disableAppealButton = true;

                api.post('/api/consultations/appeal', {id: this.consultation.id, appeal: this.appeal})
                    .then((response) => {
                        this.existingAppeal = true;

                        if (this.interlocutorNotEnter) {
                            this.setAppealInfo();
                        }
                    })
                    .catch((error) => {
                        alert(error);
                    })
                    .finally(() => {
                        this.disableAppealButton = false;
                    });
            }
        },
        watch: {
            interlocutorNotEnter: {
                handler: function (value) {
                    if (!value) {
                        if (this.user.type == 'patient') {
                            this.consultationInfoMessage = 'Пожалуйста, ожидайте врача';
                        }

                        if (this.user.type == 'doctor') {
                            this.consultationInfoMessage = 'Пожалуйста, ожидайте пациента.';
                        }
                    } else if (this.user.type == 'patient' && this.existingAppeal) {
                        this.setAppealInfo();
                    }
                },
                immediate: true
            }
        },
        created() {
            this.getOpenTokData();

            this.patientEnter = this.consultation.patient_enter;
            this.doctorEnter = this.consultation.doctor_enter;
            this.existingAppeal = this.consultation.appeal;

            window.echo.join('consultation.room.'+ this.consultation.id).here((users) => {
                this.setUsers(users);
            }).joining((user) => {
                if (user.id === this.user.id) {
                    return ErrorAlert.$emit('errorMessage', 'Похоже кто-то вошел в данную комнату онлайн-консультации, используя Вашу учетную запись.', '/account/dashboard/');
                }

                if (user.type === 'doctor') {
                    this.doctorEnter = true;
                    this.interlocutorNotEnter = false;
                }

                if (user.type === 'patient') {
                    this.patientEnter = true;
                    this.interlocutorNotEnter = false;
                }

                this.setUser(user);
            }).leaving((user) => {
                this.spliceUser(user);
            });

            window.echo.private('consultation.room.'+ this.consultation.id).listen('ConsultationEnd', ({consultationId}) => {
                return window.location.replace("/account/consultations/" + consultationId);
            });

            this.consultationInfoInternal = setInterval(() => {
                this.checkConsultationMessageInfo();
            }, this.timer);
        }
    }
</script>

<style>
    .room__message-text {
        margin-top: 20px;
        max-width: 60%;
        margin-left: 20%;
    }
</style>
